module.exports = __webpack_public_path__ + "static/media/pragati-pipeline-with-shadow.afb9372b.svg";